import { Autocomplete, SxProps, TextField, Theme } from "@mui/material";
import { useContext } from "react";
import { LayoutsConfig, MainContext } from "../context/MainContextProvider";
import { useClientClusterUsinaFilterContext } from "../context/ClientClusterUsinaFilterContextProvider";

export type SelectUsinaFilterMenuProps = {
    textFieldSx?: SxProps<Theme>
};

export default function SelectUsinaFilterMenu(props: SelectUsinaFilterMenuProps) {
    const { textFieldSx } = props;

    const { availableUsinas, selectedUsinaFilter, setSelectedUsinaFilter } =
        useClientClusterUsinaFilterContext();
    const { isMobile, layout } = useContext(MainContext);

    const usinasIds = availableUsinas?.map((usina) => usina.usinaIds.id);

    return (
        <Autocomplete
            size="small"
            className="px-2"
            value={selectedUsinaFilter?.id || ""}
            onChange={(_: any, newValue: string | null | undefined) => {
                const currentUsina = availableUsinas?.find((usina) => usina.usinaIds.id === newValue);
                setSelectedUsinaFilter(
                    { id: currentUsina?.usinaIds.id || "", name: currentUsina?.name || "" }
                );
            }}
            id="plant-select"
            options={usinasIds ?? []}
            getOptionLabel={(option) => {
                return (
                    availableUsinas?.find((usina) => usina.usinaIds.id === option)?.name ||
                    ""
                );
            }}
            sx={{ width: isMobile ? "100%" : 200 }}
            renderInput={(params) => <TextField
                sx={{
                    '& .MuiInputBase-input': {
                        color: layout == LayoutsConfig.LayoutTwo ? "#FFF" : undefined,
                    },
                    '& .MuiInputLabel-root': {
                        color: layout == LayoutsConfig.LayoutTwo ? "#8F969E" : undefined,
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                        color: layout == LayoutsConfig.LayoutTwo ? '#E9E9E9' : undefined,
                    },
                    ...textFieldSx
                }}
                {...params} label="Usina" />}
        />
    );
}
